/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfDocumentsV1DocumentState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_DOCUMENTS_V1_DOCUMENT_STATE_ENTITY_NAME = 'ixf.documents.v1.Document';
export const ixfDocumentsV1DocumentStateEntity = new schema.Entity<IxfDocumentsV1DocumentState>(IXF_DOCUMENTS_V1_DOCUMENT_STATE_ENTITY_NAME, {}, { idAttribute: 'documentId' });

